export default __webpack_public_path__ + "static/media/img_baseCrochetRattle_rose_p.8bfbe871.jpg";